import ROUTE from './names.js'

// Pre-activation set on MSK EU: the web funnel before sign-up, and in-app
// users without a prescription before doctor outreach.
export const MSK_PRE_SIGNUP_STEPS = [
  ROUTE.ASSESSMENT_SELF_TEST_WORST_PAIN_LOCATION,
  ROUTE.ASSESSMENT_SELF_TEST_PRE_SIGNUP_REFLECTION_PAIN_LOCATION,
  ROUTE.ASSESSMENT_SELF_TEST_PAIN_INTENSITY,
  ROUTE.ASSESSMENT_SELF_TEST_PRE_SIGNUP_REFLECTION_PAIN_LEVEL,
  ROUTE.ASSESSMENT_SELF_TEST_PAIN_DURATION,
  ROUTE.ASSESSMENT_SELF_TEST_PRE_SIGNUP_REFLECTION_PAIN_DURATION,
  ROUTE.ASSESSMENT_SELF_TEST_PREVIOUS_TREATMENT,
  ROUTE.ASSESSMENT_SELF_TEST_PRE_SIGNUP_REFLECTION_PREVIOUS_TREATMENT,
  ROUTE.ASSESSMENT_SELF_TEST_GOAL,
  ROUTE.ASSESSMENT_SELF_TEST_PRE_SIGNUP_COMPLETE,
]

// MSK EU post-activation set when the goal is already stored (web funnel and
// in-app no-prescription users answered it with the pre-activation set).
export const MSK_EU_POST_ACTIVATION_STEPS = [
  ROUTE.ASSESSMENT_SELF_TEST_WELCOME,
  ROUTE.ASSESSMENT_SELF_TEST_PAIN_INTENSITY,
  ROUTE.ASSESSMENT_SELF_TEST_ACTIVITIES,
  ROUTE.ASSESSMENT_SELF_TEST_FEAR_OF_MOVEMENT,
  ROUTE.ASSESSMENT_SELF_TEST_ABOUT,
  ROUTE.ASSESSMENT_SELF_TEST_PRECAUTIONS_MSK,
  ROUTE.ASSESSMENT_SELF_TEST_COMPLETE,
]

// MSK EU post-activation set when nothing was answered before activation. The
// program overview is the pre-activation set's closing screen, here the last
// step: it completes the self test in place of the congratulations screen.
export const MSK_EU_FULL_STEPS = [
  ROUTE.ASSESSMENT_SELF_TEST_WELCOME,
  ROUTE.ASSESSMENT_SELF_TEST_WORST_PAIN_LOCATION,
  ROUTE.ASSESSMENT_SELF_TEST_PAIN_INTENSITY,
  ROUTE.ASSESSMENT_SELF_TEST_PAIN_DURATION,
  ROUTE.ASSESSMENT_SELF_TEST_ACTIVITIES,
  ROUTE.ASSESSMENT_SELF_TEST_FEAR_OF_MOVEMENT,
  ROUTE.ASSESSMENT_SELF_TEST_ABOUT,
  ROUTE.ASSESSMENT_SELF_TEST_PRECAUTIONS_MSK,
  ROUTE.ASSESSMENT_SELF_TEST_GOAL,
  ROUTE.ASSESSMENT_SELF_TEST_PRE_SIGNUP_COMPLETE,
]

// US MSK, signed in without a subscription.
export const MSK_PRE_SUBSCRIPTION_STEPS = [
  ROUTE.ASSESSMENT_SELF_TEST_ABOUT,
  ROUTE.ASSESSMENT_SELF_TEST_WORST_PAIN_LOCATION,
  ROUTE.ASSESSMENT_SELF_TEST_PAIN_INTENSITY,
  ROUTE.ASSESSMENT_SELF_TEST_PAIN_DURATION,
  ROUTE.ASSESSMENT_SELF_TEST_ACTIVITIES,
  ROUTE.ASSESSMENT_SELF_TEST_FEAR_OF_MOVEMENT,
  ROUTE.ASSESSMENT_SELF_TEST_PRECAUTIONS_MSK,
  ROUTE.ASSESSMENT_SELF_TEST_PRE_SUBSCRIPTION_COMPLETE,
]

// US MSK with a subscription.
export const MSK_FULL_STEPS = [
  ROUTE.ASSESSMENT_SELF_TEST_WELCOME,
  ROUTE.ASSESSMENT_SELF_TEST_ABOUT,
  ROUTE.ASSESSMENT_SELF_TEST_WORST_PAIN_LOCATION,
  ROUTE.ASSESSMENT_SELF_TEST_PAIN_INTENSITY,
  ROUTE.ASSESSMENT_SELF_TEST_PAIN_DURATION,
  ROUTE.ASSESSMENT_SELF_TEST_ACTIVITIES,
  ROUTE.ASSESSMENT_SELF_TEST_FEAR_OF_MOVEMENT,
  ROUTE.ASSESSMENT_SELF_TEST_PRECAUTIONS_MSK,
  ROUTE.ASSESSMENT_SELF_TEST_COMPLETE,
]

export const COPD_STEPS = [
  ROUTE.ASSESSMENT_SELF_TEST_WELCOME,
  ROUTE.ASSESSMENT_SELF_TEST_PRECAUTIONS_COPD,
  ROUTE.ASSESSMENT_SELF_TEST_ABOUT,
  ROUTE.ASSESSMENT_SELF_TEST_PAIN_INTENSITY,
  ROUTE.ASSESSMENT_SELF_TEST_ACTIVITIES,
]
